import Step from '../step/Step.vue';

export default function WizardStepMixin() {
    return {
        // components: {
        //     Step,
        // },
        // props: {
        //     index: Number,
        //     stepInstances: Array,
        //     filters: Object,
        // },
        data() {
            return {
                status: 'invalid',
            };
        },
        // created() {
        //     // Register itself to the instance Array
        //     this.insertStepInstance();
        // },
        // destroyed() {
        //     // Remove itself from the instace Array
        //     this.removeStepInstance();
        // },

        methods: {

            validate() {
                // eslint-disable-next-line no-console
                console.log(`${this.$options.name} has no validation func implemented yet`);
                this.status = 'complete';
            },
            // isStepInstantiated(step) {
            //     return this.stepInstances.find((stepInstance) => stepInstance.$options.name === step.name);
            // },
            nextStep() {
                this.$emit('complete', this.$el);
            },
            insertStep(step, index) {
                return new Promise((resolve) => {
                    // Insert the step
                    this.$emit('insertStep', step, index);

                    // Validate if the step is added and instantiated
                    const loopFunc = () => {
                        setTimeout(() => (this.isStepInstantiated(step) ? resolve() : loopFunc()), 10);
                    };
                    loopFunc();
                });
            },
            removeStep(step) {
                return new Promise((resolve) => {
                    // Insert the step
                    this.$emit('removeStep', step);

                    // Validate if the step is added and instantiated
                    const loopFunc = () => {
                        setTimeout(() => (!this.isStepInstantiated(step) ? resolve() : loopFunc()), 10);
                    };
                    loopFunc();
                });
            },
            insertStepInstance() {
                this.stepInstances.splice(this.index, 0, this);
            },
            removeStepInstance() {
                this.stepInstances.splice(this.stepInstanceIndex, 1);
            },
            inViewport(stepInstance = this) {
                const currentInstanceElementBoundingRect = stepInstance.$el.getBoundingClientRect();
                return (
                    currentInstanceElementBoundingRect.top >= 0
                    && currentInstanceElementBoundingRect.left >= 0
                    && currentInstanceElementBoundingRect.bottom <= (window.innerHeight || document.documentElement.clientHeight)
                    && currentInstanceElementBoundingRect.right <= (window.innerWidth || document.documentElement.clientWidth)
                );
            },
            waitForInViewport(stepInstance) {
                return new Promise((resolve) => {
                    const loopFunc = () => setTimeout(() => (this.inViewport(stepInstance) ? resolve() : loopFunc()), 10);
                    loopFunc();
                });
            },
            scrollIfPrefilled(filterValue, fieldValue) {
                if (filterValue === fieldValue) {
                    this.nextStep();
                }
            },
        },
        watch: {
            status: {
                handler() {
                    if (this.status === 'invalid' && this === this.firstInvalidStepInstance) {
                        this.waitForInViewport(this.firstInvalidStepInstance)
                            .then(() => {
                                if (this.status === 'active') {
                                    this.$el.querySelectorAll('.field')
                                        .forEach((element) => {
                                            if (typeof element.animate !== 'undefined') {
                                                element.animate(
                                                    [
                                                        { opacity: '0' },
                                                        { opacity: '1' },
                                                    ],
                                                    {
                                                        easing: 'ease-in-out',
                                                        iterations: 2,
                                                        duration: 500,
                                                    },
                                                );
                                            }
                                        });
                                }
                            });
                    }
                },
                immediate: false,
            },
        },
    };
}
